import React from "react";

export default function Ical() {
  return (
    <iframe
    
      src="https://calendar.google.com/calendar/embed?height=600&amp;wkst=1&amp;bgcolor=%23616161&amp;ctz=America%2FNew_York&amp;src=YTFlaWRmbmsxcWZnNHBkZHNpcnRzbzU5aTRAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=ZW4udXNhI2hvbGlkYXlAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&amp;color=%23009688&amp;color=%230B8043"
      style={{ border: "solid 1px #777", width:"500px", height:"400px", frameborder:"0", scrolling:"no" }}
    ></iframe>
  );
}
